const input = {
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    email: 'Email',
    phone_number: 'Số điện thoại',
    confirm_password: 'Xác nhận mật khẩu',
    search_region_code: 'Tìm mã vùng',
    backup_code: 'Mã dự phòng',
    code: 'Mã',
    label_with_optional: '{{label}} (Không bắt buộc)',
};
export default Object.freeze(input);
